export function formatUSD(
  amount: number | string,
  minimumFractionDigits: number = 0,
  maximumFractionDigits: number = minimumFractionDigits
): string {
  return parseFloat(String(amount)).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
    maximumFractionDigits,
  });
}
